<template>
    <div>
        <span v-if="month > 0">{{ month }}</span>
        <span v-else><i class="fas fa-question-circle text-warning" /></span>
    </div>
</template>

<script>
export default {
    name: 'EndOfExercise',

    props: ['month'],
}
</script>
